/**
 * Increment a number by one.
 */
export const increment = (input) => input + 1;
//# sourceMappingURL=increment.js.map